import React from 'react'

const index = () => {
  return (
    <div>Leave</div>
  )
}

export default index